/*
 * @Author: pangshuting 2723947616@qq.com
 * @Date: 2022-05-26 17:45:48
 * @LastEditors: pangshuting 2727947616@qq.com
 * @LastEditTime: 2022-08-16 18:02:57
 * @FilePath: \official-web\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {
  Breadcrumb,
  BreadcrumbItem,
  Page,
  CheckboxGroup,
  Checkbox,
  Message,
  Modal,
  Input,
  Button
} from 'view-design'
import 'view-design/dist/styles/iview.css'
import './assets/css/index.scss'

//接入aliPay
import aliPay from './assets/function/aliPay'

Vue.config.productionTip = false
Vue.prototype.$buryPoint = function (api, params, eventType = 'CLK', action = 'aplus.record') {
  const {
    aplus_queue
  } = window;
  console.log(this,this.GLOBAL,this.GLOBAL.isPC(),'meta');
  const { meta } = this.$route
  aplus_queue.push({
    action,
    arguments: [api, eventType, {
      ...params,
      page_name:meta.pageName,
      page_url:location.href,
      channel: this.GLOBAL.isPC() ? 'PC' : 'H5'
    }]
  });
}
// 引入下拉刷新
//import VueScroller from 'vue-scroller'
//Vue.use(VueScroller)
// import Vconsole from 'vconsole'
// if (process.env.NODE_ENV === "development") { //开发版才开启日志
//   let vConsole = new Vconsole()
//   Vue.use(vConsole)
// }

import global_ from './components/Global'
Vue.prototype.GLOBAL = global_
Vue.prototype.AlipayJSBridge = aliPay

Vue.component('Breadcrumb', Breadcrumb)
Vue.component('BreadcrumbItem', BreadcrumbItem)
Vue.component('Page', Page)
Vue.component('CheckboxGroup', CheckboxGroup)
Vue.component('Checkbox', Checkbox)
Vue.component('Modal', Modal)
Vue.component('Input', Input)
Vue.component('Button', Button)

Vue.prototype.$Message = Message

let vueMain = new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

export default vueMain



// WEBPACK FOOTER //
// ./src/main.js